import { Transform, Type } from 'class-transformer';
import { UpdatedResultDto } from '../../common/updated-result-dto';
import { DimensionOptionCodeRawDto } from '../../common/dimensions/dimension-option-code-raw-dto';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';

export class CashReceiptItemRawDto extends UpdatedResultDto {
    cmCashReceiptId: number;
    cmCashReceiptItemId: number;
    amount: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    clearDate: Date;
    description: string;
    glAccountNumber: string; // Required
    offsetGLAccountNumber: string; // Required
    subCategoryCode: string;
    reconcileStatementId: number;

    @Type(() => DimensionOptionCodeRawDto)
    dimensions: DimensionOptionCodeRawDto[];
    crudAction: string;
}
